import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import FaqsDisclaimer from '../common/FaqsDisclaimer';
import Service from '../../service/Service';

const service = new Service();

class DueDateDetails extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let articlesData = [];

        this.state = {
            FirstDateOfLMP: '',
            avgCycleDays: '',
            conceptionDate: '',
            displayDate: '',
            loggedin: false,
            IsExpected: false
        }
        if (__isBrowser__ && window.__initialData__) {
            initialData = window.__initialData__['initialData']['result'];
            delete window.__initialData__;

        } else {
            if (props.staticContext) {
                initialData = props.staticContext.initialData['initialData']['result'];
            }
        }
        this.state = { initialData: initialData };
    }
    static initialAction(reqUrl, ftk, authData, uId) {
        let qUrl = reqUrl.split('/');
        let FirstDateOfLMP = qUrl[4];
        let avgCycleDays = qUrl[5];
        let conceptionDate = qUrl[6];
        let isNewEntry = 1;

        if (FirstDateOfLMP == 0) {
            FirstDateOfLMP = "";
        }
        if (avgCycleDays == 0) {
            avgCycleDays = "";
        }
        if (conceptionDate == 0) {
            conceptionDate = "";
        }
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "duedate/getduedatedetails";
        let body = JSON.stringify({
            "FirstDateOfLMP": FirstDateOfLMP,
            "avgCycleDays": avgCycleDays,
            "conceptionDate": conceptionDate,
            "isNewEntry": isNewEntry
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        
        let qUrl = this.props.match.url.split('/');
        this.state.FirstDateOfLMP = qUrl[4];
        this.state.avgCycleDays = qUrl[5];
        this.state.conceptionDate = qUrl[6];
        if (this.state.FirstDateOfLMP == 0) {
            this.state.displayDate = this.state.conceptionDate;
        } else if (this.state.conceptionDate == 0) {
            this.state.displayDate = this.state.FirstDateOfLMP;
        }
        if (global.userAry['IsExpected'] || global.ftk != '') {
            this.setState({ IsExpected: true, loggedin: true });
            console.log("componentDidMount ====> true ");
        } else {
            this.setState({ IsExpected: false, loggedin: false });
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.getdueDetails();
            } else {
                localStorage.setItem('initialData', JSON.stringify(this.state.initialData));
                this.setWidth();
                this.landDueDatePage();
            }
        } else {
            if (localStorage.getItem('initialData')) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('initialData')) });
                this.setWidth();
                this.landDueDatePage();
            }
            service.hideLoader();
        }
    }
    setWidth() {
        if (window.innerWidth > 767) {
            let allArticle = document.getElementsByClassName("duedatedetail-article");
            for (let i = 0; i < allArticle.length; i++) {
                let index = allArticle[i].getAttribute("data-id");
                let article_length = document.querySelector(".article_" + index).lastChild.firstElementChild.children.length;
                document.querySelector(".article_" + index).lastChild.firstElementChild.style.width = ((article_length * 480) + ((article_length - 1) * 10)) + "px";
            }
        } else {
            var allArticle = document.getElementsByClassName("duedatedetail-article");
            for (var i = 0; i < allArticle.length; i++) {
                var index = allArticle[i].getAttribute("data-id");
                var article_length = document.querySelector(".article_" + index).lastChild.firstElementChild.children.length;
                document.querySelector(".article_" + index).lastChild.firstElementChild.style.width = ((article_length * 255) + ((article_length - 1) * 10)) + "px";
            }
        }
    }
    getdueDetails() {
        let qUrl = this.props.match.url.split('/');
        let isNewEntry = 1;
        let a = qUrl[4];
        let b = qUrl[5];

        if(qUrl[4]==0)
        {
            a="";
        }

        if(qUrl[5]==0)
        {
            b="";
        }

        var postData = {
                "FirstDateOfLMP": a,
                "avgCycleDays": b,
                "conceptionDate": qUrl[6],
                "isNewEntry": isNewEntry
        }
        var url = global.api_ci_url + "Duedate/getdueDetails";
        service.postServiceCall(url, postData).then((json) => {
            console.log("getdueDetails();::::::",json);
            if (json['result']) {
                this.setState({ initialData: json['result'] }, () => { 
                    this.landDueDatePage();
                    this.setWidth();                        
                });
                localStorage.setItem('initialData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    landDueDatePage() {
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let date = new Date(this.state.displayDate);
        this.state.displayDate = date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
        console.log("this.state.displayDate==========>",this.state.displayDate);
    }
    slideStage(e) {
        if (e.target.parentElement.classList.contains("next") || e.target.classList.contains("next")) {
            e.target.parentElement.parentElement.parentElement.scrollLeft += 480;
        } else {
            e.target.parentElement.parentElement.parentElement.scrollLeft -= 475;
        }
    }
    calculateDueDateAgain() {
        if (!navigator.onLine) {
            service.showAlert("Please check internet connection!!");
        } else {
            this.props.history.push(service.getRedirectUrl("/tools/pregnancy-due-date-calculator?callAgain=y"));
        }
    }
    render() {
        return (
            <main className="duedate-tool main-container">
                <Helmet
                    title="Pregnancy Due Date Calculator – Figure Out Your Date of Delivery"
                    meta={[
                        { "name": "description", "content": "Excited to know when will your baby arrives? Use our super easy pregnancy due date calculator to calculate your baby’s estimated due date right away!" },
                        { "name": "keywords", "content": "due date calculator, pregnancy due date calculator, baby due date calculator, delivery date calculator, due date calculator week by week" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Due Date Calculator</span>
                    </div>
                    <h1 className="B24_00">Due Date Details </h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="duedatedetail-container duedatedetail">
                            <div className="duedatedetail-date">
                                <span className="icon calendar-icon" data-icon-font="w"></span>
                                <div id="dueCurrentDate" className="R14_9e">
                                    {this.state.displayDate}
                                </div>
                                {
                                    this.state.avgCycleDays != "" && this.state.avgCycleDays != 0 ?
                                        (<div>
                                            <div className="R14_9e"> | </div>
                                            <div className="R14_9e">
                                                {this.state.avgCycleDays} Days </div>
                                        </div>
                                        ) : null
                                }
                            </div>
                            {this.state.initialData && this.state.initialData.length > 0 && this.state.initialData.map((result, index) => result.index == 1 ?
                                (<div className="duedatedetail-block">
                                    <div className="duedatedetail-smiley">
                                        <div data-icon-font="&#xe04a;" className="icon" ></div>
                                    </div>
                                    <div className="duedatedetail-data">
                                        <div className="duedatedetail-congo">
                                            <span>Congratulations!</span>
                                        </div>
                                        <div className="duedatedetail-msg">
                                            <span>{result.question} <b> {result.date}</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                ) :

                                (
                                    <div>
                                        <div className={"duedatedetail-article article_" + result.index} data-id={result.index}>
                                            <div className="duedatedetail-dates">
                                                <div className="duedatedetail-dtitle">
                                                    <span className="M15_42">{result.question}</span>
                                                </div>
                                                <div className="duedatedetail-odate">
                                                    <div className="R15_9e">{result.date}</div>
                                                </div>
                                            </div>
                                            <div className="duedate-slider">
                                                <ul className="slider fl">
                                                    {this.state.initialData && result.article.map((article, index1) =>
                                                        <li className="slide" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)} key={index1}>
                                                            <Link to={service.getRedirectUrl(article['articleUrl'].replace("http://", "https://"))}>
                                                                <div className="duedate-article" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)} data-id={article['articleId']}>
                                                                    <div className="duedate-img" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                                        <img className="entry-thumb td-animation-stack-type0-2" src={article['articleImage'].replace("http://", "https://", article['articleImage'])} alt={article['articleTitle']} title={article['articleTitle']} id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)} />
                                                                    </div>
                                                                    <div className="duedate-acontent" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                                        <span className="R14_42" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>
                                                                            {article.articleTitle}
                                                                        </span>
                                                                        <div className="readmorelink R14_link" id={"Level no " + (index + 1) + '|' + "Article no " + (index1 + 1)}>Read More</div>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    )}
                                                </ul>
                                                <div className="arrows">
                                                    <span className="next" onClick={(e) => { this.slideStage(e) }}><span data-icon-font="h" className="icon"></span></span>
                                                    <span className="prev" onClick={(e) => { this.slideStage(e) }}><span data-icon-font="g" className="icon"></span></span>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="divider_line"></div>
                                    </div>
                                ))}
                             <div id="duedateCalBtn" className="askB_1 calculateAgain" onClick={() => { this.calculateDueDateAgain() }}>
                                <p title="Calculate  My Due Date" className="clcdueagain">
                                    <span className="clcdueagain">CALCULATE AGAIN</span>
                                </p>
                            </div>
                            {/*<div className="duedate-btn-block duedatedetail-obtn">
                                <div className="duedate-btn faq faqDisclaimer">
                                    <div id="duedateBtn" data-id="ios" className="faqperiodbtn" onClick={() => { actions.FAQs(this) }}>
                                        <p title="Period & Ovulation FAQs">
                                            <span className="M14_9e textdata">FAQs</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="duedate-btn disclaimer">
                                    <div id="duedateBtn" data-id="ios" className="faqperiodbtn" onClick={() => { actions.Disclaimer(this) }}>
                                        <p title="Period & Ovulation Disclaimer">
                                            <span className="M14_9e textdata">Disclaimer</span>
                                        </p>
                                    </div>
                                </div>
                            </div> */}
                            <FaqsDisclaimer eleRef={this} />
                        </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default DueDateDetails;



// WEBPACK FOOTER //
// src/shared/tools/Duedate/DueDateDetails.js